export const getSsoRoute = (mode: 'authenticate' | 'logout' = 'authenticate') => {
  let ssoRoute = 'https://www.deltadefense.com';

  try {
    const hostname = location.hostname;
    const isDev = hostname.includes('dev.www');
    const isStaging = !isDev && ['localhost', 'staging', 'usccadev', 'deltadefensedev'].some(e => hostname.includes(e));

    if (isDev) {
      ssoRoute = 'https://dev.www.deltadefensedev.com';
    } else if (isStaging) {
      ssoRoute = 'https://www.deltadefensedev.com';
    }
  } catch (error) {
    // ignore
  }

  return `${ssoRoute}/${mode}`;
};
